var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.pageMounted)?_c('div',[_c('Header'),_c('main',{attrs:{"id":"main","role":"main"}},[_c('router-view')],1),_c('Toast',{ref:"toastComponent"}),_c('Noise')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }